/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VideoQualityResponse { 
    video_id: string;
    overall_score: number;
    azimutal_enabled: number;
    resolution_width?: number | null;
    resolution_height?: number | null;
    fps?: number | null;
    quality_color: string;
}

